import {PageData} from "@app/core-app/app/usecase/notion/fetch-pages";
import useSWR, {KeyedMutator} from "swr";
import {fetcher} from "./fetcher";
import {EmailLogEntry} from "@app/core-app/app/data/email-log-entry";
import {InboxEmailEntity} from "@app/core-app/app/data/inbox-email-entity";

export type InboxEmailLogData = {
  data: InboxEmailEntity[] | null | undefined
  isLoading: boolean
  isError: any
  isValidating: boolean
  mutate: KeyedMutator<InboxEmailEntity[]>
}


export function useInboxLog(databaseId: string | null): InboxEmailLogData {
  const {data, error, mutate, isValidating} = useSWR(
    databaseId ? ["/api/notion/inbox-log", databaseId] : null,
    (key, id) => fetcher(key, {method: "POST", body: JSON.stringify({id: id})})
  )

  return {
    data: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
    isValidating
  }
}
